import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgArrowsCycle = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6.375 13.8733V17.6233H2.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.625 10.1233V6.37334H21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.86 6.37083C19.1531 7.71798 19.9428 9.46933 20.0963 11.3303C20.2498 13.1913 19.7578 15.0484 18.7029 16.5892C17.6481 18.13 16.0948 19.2606 14.3043 19.7907C12.5138 20.3208 10.5954 20.2182 8.8717 19.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.1392 17.6258C4.84893 16.278 4.0617 14.5273 3.90971 12.6676C3.75772 10.808 4.25022 8.95264 5.3045 7.41319C6.35879 5.87374 7.91065 4.74392 9.69951 4.21344C11.4884 3.68297 13.4053 3.78415 15.1284 4.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgArrowsCycle.displayName = 'SvgArrowsCycle';
export default SvgArrowsCycle;
